import { useEffect } from 'preact/hooks';
import { signal } from '@preact/signals';
import { api, ApiError } from '../api/client';
import { user, fetchMe } from '../stores/auth.store';
import { route } from 'preact-router';
import { Spinner, Button, SkeletonBar } from '../components/ui';
import { T } from '../styles/tokens';
import { TwoFactorVerify } from '../components/TwoFactorVerify';

const error = signal('');
const status = signal<'verifying' | 'switching' | 'error' | '2fa'>('verifying');
const tempToken2FA = signal('');

export function AuthCallbackPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const is2fa = params.get('2fa');
    const urlTempToken = params.get('tempToken');

    // Se veio de login com senha e precisa de 2FA
    if (is2fa && urlTempToken) {
      tempToken2FA.value = urlTempToken;
      status.value = '2fa';
      return;
    }

    if (!token) {
      error.value = 'Token não encontrado na URL';
      status.value = 'error';
      return;
    }

    // If user is already logged in, show "switching account" state
    if (user.value) {
      status.value = 'switching';
    }

    // Clear client-side auth state before verifying new magic link
    user.value = null;

    api.post<any>(`/auth/verify`, { token })
      .then(async (res: any) => {
        // Verificar se precisa de 2FA
        if (res?.requires_2fa && res?.tempToken) {
          tempToken2FA.value = res.tempToken;
          status.value = '2fa';
          return;
        }
        await fetchMe();
        route('/chat');
      })
      .catch((err) => {
        const msg = err instanceof ApiError ? err.message : 'Erro ao verificar token';
        // Provide clearer message for expired/invalid tokens
        if (msg.includes('inválido') || msg.includes('expirado') || msg.includes('INVALID_TOKEN')) {
          error.value = 'Este link expirou ou já foi utilizado. Solicite um novo link de acesso.';
        } else {
          error.value = msg;
        }
        status.value = 'error';
      });
  }, []);

  // Tela de verificação 2FA
  if (status.value === '2fa') {
    return <TwoFactorVerify tempToken={tempToken2FA.value} />;
  }

  if (status.value === 'error') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div class="card" style={{ maxWidth: 420, textAlign: 'center' }}>
 <div style={{ fontSize: 48, marginBottom: 16 }}></div>
          <h2>Erro na verificação</h2>
          <p style={{ color: T.textMuted, marginTop: 8 }}>{error.value}</p>
          <Button variant="ghost" class="btn btn-primary" style={{ marginTop: 20 }} onClick={() => route('/chat')}>
            Solicitar novo link
          </Button>
        </div>
      </div>
    );
  }

  return (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', gap: 16 }}><SkeletonBar width={200} height={20} /><SkeletonBar width={140} height={14} /></div>);
}
